import { BotProductCardSeriesMessage } from '@/types';
import { motion } from 'framer-motion';
// @ts-ignore
import 'swiper/css';
// @ts-ignore
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import MessageProductCard from './MessageProductCard';
import { SliderArrows, useSliderArrows } from './shared/SliderArrows';

type MessageProductCardSeriesProps = {
  message: BotProductCardSeriesMessage;
  messageId: string;
};

const MessageProductCardSeries = ({ message, messageId }: MessageProductCardSeriesProps) => {
  const {
    prevButtonRef,
    nextButtonRef,
    isBeginning,
    isEnd,
    navigation,
    onSwiper,
    onSlideChange,
    onBeforeInit,
  } = useSliderArrows();

  return (
    <motion.div
      className="group relative mx-[-20px] flex max-w-[calc(100%+40px)] flex-col overflow-visible"
      layoutId={`${messageId}-product-card-series`}
      key={`${messageId}`}
    >
      <Swiper
        className="w-full !overflow-visible !px-[20px] [&>.swiper-wrapper]:!overflow-visible"
        slidesPerView={'auto'}
        spaceBetween={8}
        modules={[Navigation]}
        navigation={navigation}
        onSwiper={onSwiper}
        onSlideChange={onSlideChange}
        onBeforeInit={onBeforeInit}
      >
        {message.content.map(product => (
          <SwiperSlide className="max-w-[80%]" key={product.id}>
            <MessageProductCard
              message={{
                role: 'assistant',
                type: 'productCard',
                content: product,
              }}
              messageId={`${messageId}-${product.id}`}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <SliderArrows
        prevButtonRef={prevButtonRef}
        nextButtonRef={nextButtonRef}
        isBeginning={isBeginning}
        isEnd={isEnd}
      />
    </motion.div>
  );
};

export default MessageProductCardSeries;
